if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.freeShippingThreshold = 10000;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = new FormData(this.form);
        const variantId = formData.get('id');

        let sections = null;
        if (this.cart) {
          sections = this.cart.getSectionsToRender().map((section) => section.id);
          this.cart.setActiveElement(document.activeElement);
        }

        // Always use the normal form payload now
        delete config.headers['Content-Type'];

        if (sections) {
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker =
              CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response
              }).then(() => {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              });
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      'add:paint-updated-sections',
                      () => {
                        this.cart.renderContents(response);
                      }
                    );
                    this.afterCartAdd();
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
              this.afterCartAdd();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      async afterCartAdd() {
        try {
          const res = await fetch('/cart.js', {
            headers: { Accept: 'application/json' }
          });
          if (!res.ok) throw new Error('Cart fetch failed');

          const cart = await res.json();
          this.renderFreeShippingMessage(cart);
          this.renderCartBubble(cart);
        } catch (err) {
          console.error('afterCartAdd error:', err);
        }
      }

      formatMoneyFromCents(cents) {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(cents / 100);
      }

      renderFreeShippingMessage(cart) {
        const el = document.getElementById('freeshipping');
        if (!el) return;

        const cartTotal = cart.total_price;

        if (cartTotal >= this.freeShippingThreshold) {
          el.innerHTML =
            'Free Shipping Unlocked!<a href="/policies/shipping-policy">*</a>';
        } else {
          const remaining = this.freeShippingThreshold - cartTotal;
          el.innerHTML = `
            Add <span id="freeshipping-amount" style="color:#980e1d;font-weight:700;">
              ${this.formatMoneyFromCents(remaining)}
            </span> more to your cart for free shipping!<a href="/policies/shipping-policy">*</a>
          `;
        }
      }

      renderCartBubble(cart) {
        const cartIcon = document.querySelector('#cart-icon-bubble');
        if (!cartIcon) return;

        let bubble = cartIcon.querySelector('.cart-count-bubble');
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble hidden';
          bubble.innerHTML = `
            <span aria-hidden="true"></span>
            <span class="visually-hidden"></span>
          `;
          cartIcon.appendChild(bubble);
        }

        const visible = bubble.querySelector('span[aria-hidden="true"]');
        const hidden = bubble.querySelector('.visually-hidden');
        if (!visible || !hidden) return;

        if (cart.item_count > 0) {
          bubble.classList.remove('hidden');
          visible.textContent = cart.item_count;
          hidden.textContent = `${cart.item_count} item${
            cart.item_count === 1 ? '' : 's'
          }`;

          const svg = cartIcon.querySelector('svg');
          if (svg && svg.classList.contains('icon-cart-empty')) {
            svg.classList.remove('icon-cart-empty');
            svg.classList.add('icon-cart');
          }
        } else {
          bubble.classList.add('hidden');
          visible.textContent = '';
          hidden.textContent = '';

          const svg = cartIcon.querySelector('svg');
          if (svg && svg.classList.contains('icon-cart')) {
            svg.classList.remove('icon-cart');
            svg.classList.add('icon-cart-empty');
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}